<template>
  <div>
    <Calendar calendar="phone" />
  </div>
</template>

<script>
import Calendar from '../../components/calendar/Calendar.vue'
export default {
  components: {
    Calendar
  }
}
</script>

<style scoped>

</style>